// extracted by mini-css-extract-plugin
export default {"backdrop":"style_backdrop__cB0Ro","modal":"style_modal__FwQiV","slide-down":"style_slide-down__aWDlK","closeBtn":"style_closeBtn__Q2jY7"};